<template>
    <audio
        class="audio-player"
        ref="audio"
        :src="url"
        preload="metadata"
        @error="error"
        @ended="ended"></audio>
</template>

<script>
    import wx from 'weixin-js-sdk'
    import eventBus from '@/event_bus'
    import { PLAYER_NAME } from './data'
    import {
        audioBrowser,
        audioWechat
    } from './utils/players'

    export default {
        name: 'TheAudioPlayer',
        data () {
            return {
                url: '', // for broswer
                localId: '', // for wechat
                lastLocalId: '', // for wechat
                uuid: '', // 语音的 id（无论 browser、wechat）
                lastUUID: '' // 上一条播放过语音的 id
            }
        },
        computed: {
            isWechatJSSDKReady () {
                return eventBus.isWechatJSSDKReady
            },
            curPlayer () {
                if (this.url) {
                    return audioBrowser
                } else if (this.localId) {
                    return audioWechat
                } else {
                    return null
                }
            }
        },
        watch: {
            curPlayer (curPlayer, lastPlayer) {
                if (lastPlayer !== null) {
                    const lastPlayerName = this.lastPlayer.name
                    switch (lastPlayerName) {
                        case PLAYER_NAME.BROWSER:
                            this.stop(this.getPlayerParamByName(PLAYER_NAME.BROWSER))
                            break
                        case PLAYER_NAME.WECHAT:
                            this.stop(this.getPlayerParamByName(PLAYER_NAME.WECHAT))
                            break
                    }
                }
            },
            isWechatJSSDKReady (value) {
                if (value) {
                    wx.onVoicePlayEnd({
                        complete: () => {
                            this.emitStop(this.uuid)
                        }
                    })
                }
            },

        },
        methods: {
            setUrl ({ uuid, url, localId }) {
                // 不是第一次点击语音
                if (this.uuid !== '') {
                    this.stop(this.uuid)
                    this.lastUUID = this.uuid
                    this.emitStop(this.lastUUID)
                }
                // 用于暂停微信语音
                if (this.localId) {
                    this.lastLocalId = this.localId
                }
                this.uuid = uuid
                this.url = url || ''
                this.localId = localId || ''
            },
            play () {
                this.$videoPlayer.close()
                if (this.curPlayer) {
                    this.curPlayer.play(this.getPlayerParam())
                }
            },
            pause () {
                if (this.curPlayer) {
                    this.curPlayer.pause(this.getPlayerParam())
                    this.emitStop(this.uuid)
                }
            },
            stop () {
                if (this.curPlayer) {
                    this.curPlayer.stop(this.getPlayerParam())
                    this.emitStop(this.uuid)
                }
            },
            getPlayerParamByName (name) {
                switch (name) {
                    case PLAYER_NAME.WECHAT:
                        return this.lastLocalId
                    case PLAYER_NAME.BROWSER:
                        return this.$refs.audio
                }
            },
            getPlayerParam () {
                if (this.url) {
                    return this.$refs.audio
                } else if (this.localId) {
                    return this.localId
                }
                return
            },
            emitStop (uuid) {
                eventBus.$emit(`AUDIO_STOP_${uuid}`)
            },
            // S browser 专用
            error () {
                this.emitStop(this.uuid)
            },
            ended () {
                this.emitStop(this.uuid)
            }
            // E browser 专用
        }
    }
</script>

<style lang="scss" scoped>

</style>
